import { bool } from "prop-types";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import UspsVerifiedPill from "./UspsVerifiedPill";

/**
 * The "USPS Verified" status badge — a pure, non-interactive indicator that the typed address
 * matched a Smarty leaf. `show` (the hook's `uspsVerified`) drives its opacity toggle. Placement and
 * per-surface rules (which surfaces show it, the admin double-badge avoidance) live in the
 * feature's SURFACES.md.
 */
export default function UspsVerifiedBadge({ show }) {
  return (
    <FnrOpacityToggle show={show}>
      <UspsVerifiedPill />
    </FnrOpacityToggle>
  );
}

UspsVerifiedBadge.propTypes = {
  show: bool,
};
